import type { LocalizedText } from "../types";

export interface PrivacySection {
  heading: LocalizedText;
  body: LocalizedText[];
}

export interface PrivacyPolicy {
  updated: string;
  sections: PrivacySection[];
}

export const privacyPolicy: PrivacyPolicy = {
  updated: "2026-06-29",
  sections: [
    {
      heading: { ru: "Что это", en: "Overview" },
      body: [
        {
          ru: "Эта политика описывает, какие данные собирает игра BreachGuard Bureau и как они используются. BreachGuard Bureau - обучающая симуляция; все компании и события в ней вымышлены.",
          en: "This policy describes what data the game BreachGuard Bureau collects and how it is used. BreachGuard Bureau is a training simulation; all companies and events in it are fictional.",
        },
      ],
    },
    {
      heading: { ru: "Какие данные мы собираем", en: "What data we collect" },
      body: [
        {
          ru: "Анонимный идентификатор (случайный UUID, не связан с вашей личностью), игровые события (прохождение контрактов, покупки за внутриигровую валюту, прогресс), а также технические числа и категории (например, грейд результата, уровень).",
          en: "An anonymous identifier (a random UUID not tied to your identity), gameplay events (contract completions, in-game-currency purchases, progress), and technical numbers and categories (e.g. result grade, level).",
        },
        {
          ru: "Мы НЕ собираем: имя, email, точную геолокацию, содержимое экрана или ввод. IP-адрес анонимизируется и не хранится.",
          en: "We do NOT collect: name, email, precise geolocation, screen content or input. The IP address is anonymized and is not stored.",
        },
      ],
    },
    {
      heading: { ru: "Кто обрабатывает данные", en: "Who processes the data" },
      body: [
        {
          ru: "Продуктовая аналитика - PostHog (серверы в ЕС, eu.i.posthog.com). Диагностика ошибок - Sentry (серверы в ЕС, de.sentry.io). Обе службы настроены не сохранять IP-адрес.",
          en: "Product analytics - PostHog (EU servers, eu.i.posthog.com). Error diagnostics - Sentry (EU servers, de.sentry.io). Both services are configured not to store the IP address.",
        },
      ],
    },
    {
      heading: { ru: "Зачем", en: "Why" },
      body: [
        {
          ru: "Чтобы улучшать игровой баланс, находить и исправлять ошибки и понимать, какие функции используются.",
          en: "To improve game balance, find and fix bugs, and understand which features are used.",
        },
      ],
    },
    {
      heading: { ru: "Согласие и отказ", en: "Consent and opt-out" },
      body: [
        {
          ru: "Аналитика включена по умолчанию, о чём сообщает нотис при первом запуске. Вы можете отказаться в любой момент: Настройки -> Конфиденциальность -> Отказаться. При отказе внешняя аналитика (PostHog, Sentry) отключается.",
          en: "Analytics is on by default, as the first-run notice states. You can opt out at any time: Settings -> Privacy -> Opt out. On opt-out, third-party analytics (PostHog, Sentry) is disabled.",
        },
      ],
    },
    {
      heading: { ru: "Хранение", en: "Retention" },
      body: [
        {
          ru: "Данные хранятся на серверах в ЕС в течение ограниченного срока, заданного настройками хранения аналитики.",
          en: "Data is stored on EU servers for a limited period set by the analytics retention settings.",
        },
      ],
    },
    {
      heading: { ru: "Игровые площадки", en: "Game platforms" },
      body: [
        {
          ru: "При игре на сторонних площадках (например, Yandex Games, CrazyGames, GamePix) дополнительно действуют их собственные политики конфиденциальности.",
          en: "When playing on third-party platforms (e.g. Yandex Games, CrazyGames, GamePix), their own privacy policies additionally apply.",
        },
      ],
    },
    {
      heading: { ru: "Контакт", en: "Contact" },
      body: [
        {
          ru: "По вопросам обработки данных: ivan.senishin@gmail.com.",
          en: "For data-processing questions: ivan.senishin@gmail.com.",
        },
      ],
    },
  ],
};
